import {
  Button,
  chakra,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput, FormMultiSelect } from "../../../../components/Forms";
import { VALIDATION_PATTERNS } from "../../../../utils";
import * as React from "react";
import { useEffect } from "react";
import assert from "utils/assert";
/**
 * @param {Object} modalData - _almost_ a user object, but with roles changed to [{label:string, value:number}]
 * TODO: refactor to use the actual user object. Rendering choices should be done at the last moment.
 * @param {[{id:number, role:string}]} safeRoles - roles that the current user can manage
 * @param {[{id:number, role:string}]} roles - all roles
 * @returns 
 */
function UserModal({ modalData, isOpen, onClose, onSubmit, roles, safeRoles }) {
	assert( ! roles)
	assert(safeRoles);
  const { t } = useTranslation("translation", {
    keyPrefix: "userManagement.userModal"
  });
  const { t: globalTranslation } = useTranslation("translation");
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control
  } = useForm({
    defaultValues: modalData
  });

  const onModalClose = () => {
    onClose();
  };

  const prepareSubmitData = data => {
    const mappedData = {
      ...data,
      roleIds: data.roles.map(el => el.value)
    };
    delete mappedData["roles"];
    onSubmit(modalData?.id, mappedData);
  };

  useEffect(() => {
    reset(modalData);
  }, [reset, modalData, isOpen]);

  const showRoles = safeRoles;
  // add any that the modalData has but are not in safeRoles
  // Note: ugly code, because modalData uses a custom format (TODO refactor that)
  const missingRoles = modalData?.roles
    ?.filter(mdRole => !safeRoles.some(safeRole => safeRole.id === mdRole.value))
    .map(mdRole => { return { id: mdRole.value, role: mdRole.label }; });
  if ( missingRoles?.length > 0 ) {
    showRoles.push(...missingRoles);
  }
  // console.log("modalData", modalData, "roles", roles, "safeRoles", safeRoles, "showRoles", showRoles);

  return isOpen ? <Modal isOpen={isOpen} onClose={onModalClose} size="md">
    <ModalOverlay />
    <ModalContent>
      <chakra.form onSubmit={handleSubmit(prepareSubmitData)}>
        <ModalHeader>{modalData ? "Manage User Details" : t("createUserHeader")}</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Flex direction="column" gap="2" marginBottom={10}>
            {!modalData && <FormInput
              label={`${t("labels.username")} *`}
              placeholder={t("placeholders.username")}
              type="email"
              errors={errors}
              {...register("username",
                {
                  required: !modalData ? globalTranslation("entityRequired", { entityName: t("labels.username") }) : false,
                  pattern: VALIDATION_PATTERNS.EMAIL_ADDRESS
                })}
              maxInlineSize={"var(--chakra-sizes-full)"}
            />}
            <FormInput
              label={`${t("labels.firstName")} *`}
              placeholder={t("placeholders.firstName")}
              errors={errors}
              {...register("firstName", {
                required: globalTranslation("entityRequired", { entityName: t("labels.firstName") })
              })}
              maxInlineSize={"var(--chakra-sizes-full)"}
            />
            <FormInput
              label={`${t("labels.lastName")} *`}
              placeholder={t("placeholders.lastName")}
              errors={errors}
              {...register("lastName", {
                required: globalTranslation("entityRequired", { entityName: t("labels.lastName") })
              })}
              maxInlineSize={"var(--chakra-sizes-full)"}
            />
            <FormMultiSelect
              control={control}
              name="roles"
              id="roles"
              options={showRoles.map(roleObj => {
                return {
                  label: globalTranslation(`userManagement.roles.${roleObj?.role}`, { defaultValue: roleObj?.role }),
                  value: roleObj?.id
                };
              })}
              placeholder={t("placeholders.userRole")}
              label={`${t("labels.userRole")} *`}
              rules={{ required: globalTranslation("entityRequired", { entityName: t("labels.userRole") }) }}
              errors={errors}
            />
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onModalClose}>
            {t("buttons.close")}
          </Button>
          <Button colorScheme="customScheme" type="submit">
            {t("buttons.save")}
          </Button>
        </ModalFooter>
      </chakra.form>
    </ModalContent>
  </Modal> : null;
}

export default UserModal;